// Helper to resolve asset URLs from backend relative paths
// Uses `VUE_APP_ASSETS_BASE_URL` when the src is not absolute
export function resolveAsset(src) {
  if (src == null) return "";
  let val = src;
  if (typeof val !== "string") {
    try {
      if (Array.isArray(val)) {
        const first = val[0];
        if (typeof first === 'string') {
          val = first;
        } else if (first && typeof first === 'object') {
          if (typeof first.images === 'string') {
            val = first.images;
          } else if (Array.isArray(first.images) && first.images.length) {
            const img0 = first.images[0];
            val = typeof img0 === 'string' ? img0 : String(img0 || '');
          } else {
            val = String(first);
          }
        } else {
          val = String(first);
        }
      } else if (val && typeof val === 'object') {
        if (typeof val.images === 'string') {
          val = val.images;
        } else if (Array.isArray(val.images) && val.images.length) {
          const img0 = val.images[0];
          val = typeof img0 === 'string' ? img0 : String(img0 || '');
        } else {
          const keys = Object.keys(val);
          if (keys.length > 0) {
            const candidate = val[keys[0]];
            val = typeof candidate === 'string' ? candidate : String(candidate || keys[0]);
          } else {
            val = String(val);
          }
        }
      } else {
        val = String(val);
      }
    } catch (_) {
      return "";
    }
  }

  const trimmed = String(val).trim();
  if (!trimmed || trimmed === '[object Object]') return "";
  try {
    const special = 'images/settings/17651114148619937.png';
    const lastImg = require('@/assets/imgs/last-img.png');
    const endsWithSpecial = trimmed.toLowerCase().endsWith(special);
    if (endsWithSpecial) return lastImg;
  } catch (_) { return trimmed; }
  // If absolute URL, normalize backend hosts to devServer proxy base to avoid ORB/CORB
  if (/^(https?:|data:|blob:)/i.test(trimmed)) {
    if (!/^https?:/i.test(trimmed)) return trimmed;
    try {
      const u = new URL(trimmed);
      const host = u.host.toLowerCase();
      let path = u.pathname.startsWith('/') ? u.pathname.slice(1) : u.pathname;
      const base = process.env.VUE_APP_ASSETS_BASE_URL || "/";
      const isDev = process.env.NODE_ENV !== 'production';
      // Known backend hosts to rewrite through dev proxy
      const rewriteHosts = [
        '127.0.0.1:8088',
        'localhost:8088',
        'ebtikar.com',
        'www.ebtikar.com',
        'ebtkarr.com',
        'www.ebtkarr.com'
      ];
      if (isDev && rewriteHosts.includes(host) && typeof base === 'string' && base.startsWith('/')) {
        const baseNorm = base.endsWith('/') ? base : base + '/';
        // Normalize common Laravel public path prefix
        path = path.replace(/^dashboard\/public\//, '');
        const adjusted = (path.startsWith('storage/') || path.startsWith('images/')) ? path : `storage/${path}`;
        return baseNorm + adjusted;
      }
    } catch (_) {
      // fall through
    }
    // Not a backend host we control; return as-is
    return trimmed;
  }
  // Already a full backend-relative path under the dev proxy
  if (trimmed.startsWith('/dashboard')) return trimmed;

  const base = process.env.VUE_APP_ASSETS_BASE_URL || "/";
  // if (!base) return trimmed;

  const baseNorm = base.endsWith("/") ? base : base + "/";
  const pathNorm = trimmed.startsWith("/") ? trimmed.slice(1) : trimmed;
  if (!pathNorm) return "";
  
  // If backend returned a relative path to an image file, serve it from public/storage
  const adjusted = (!pathNorm.startsWith('storage/') && !pathNorm.startsWith('images/'))
    ? `storage/${pathNorm}`
    : pathNorm;
  return baseNorm + adjusted;
}

// Vue plugin style installer (optional)
export default {
  install(app) {
    app.config.globalProperties.$resolveAsset = resolveAsset;
  },
};
